export const authInterceptor = (headers: Headers) => {
  const token =
    sessionStorage.getItem("AUTH_TOKEN_KEY") ??
    localStorage.getItem("AUTH_TOKEN_KEY");
  if (!token) return headers;

  headers.set("Authorization", `Bearer ${token}`);
  return headers;
};

export interface ApiResponse {
  result: any;
  message: string;
  statusCode: number;
  statusName: string;
}
